import React, { Component } from "react";

import { connect } from "react-redux";
import { auth } from "../../Firebase/firebase";
import * as actionCreators from "../../Store/actions/index";
import classes from "./EditUserForm.module.css";
import Input from "../../Component/UI/Input/Input";

class EditUserForm extends Component {

    state = {
        formValid: true,
        formError: '',
        currentImg: {
            imgEdited: false,
            editedImgSrc: null
        },
        editUserForm: {
            name: {
                inputType: 'input',
                label: 'Name',
                inputConfig: {
                    type: 'text',
                    placeholder: this.props.userProfile.name,
                    autoFocus: true
                },
                validation: {
                },
                value: '',
                valid: true,
                touched: false
            },
            userName: {
                inputType: 'input',
                label: 'User name',
                inputConfig: {
                    type: 'text',
                    placeholder: this.props.userProfile.username
                },
                validation: {
                },
                value: '',
                valid: true,
                touched: false
            },
            Phone: {
                inputType: 'input',
                label: 'Phone',
                inputConfig: {
                    type: 'text',
                    placeholder: `+${this.props.userProfile.phone}`
                },
                validation: {
                    isPhone: true,
                    minLength: 11,
                    maxLength: 14,
                },
                value: '',
                valid: true,
                touched: false
            }
        }
    }

    cheekFieldVaild = (field, rule) => {
        let isValid = true;
        let errMes = '';
        if (rule.required) {
            isValid = field.trim() !== '' && isValid;
            errMes = isValid ? '' : 'This field is rquired';
        }
        if (rule.isPhone) {
            // const pattren = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
            const pattern = /^\+/
            isValid = pattern.test(field) && isValid;
            errMes = isValid ? '' : 'Phone number should start country code '
        }
        if (rule.minLength) {
            let len = field.length
            isValid = len > rule.minLength && isValid;
            if (errMes === '') {
                errMes = isValid ? '' : 'Phone number should be (11 to 13) digit.'
            }
        }
        if (rule.maxLength) {
            let len = field.length
            isValid = len < rule.maxLength && isValid;
            if (errMes === '') {
                errMes = isValid ? '' : 'Phone number should be (11 to 13) digit.'
            }
        }
        if (rule.isEmail) {
            // const patrr = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            isValid = pattern.test(field) && isValid;
            errMes = isValid ? '' : 'email : xx@yy.com'
        }
        if (rule.matchPass) {
            isValid = field === this.state.currentPass && isValid;
            errMes = isValid ? '' : 'password dose not match';
        }
        return [isValid, errMes]
    }

    inputChangeHandler = (event, elementID) => {
        const updatedControls = { ...this.state.editUserForm }
        const changedElement = { ...updatedControls[elementID] };
        const checkVaildity = this.cheekFieldVaild(event.target.value, changedElement.validation);
        changedElement.valid = checkVaildity[0];
        changedElement.errMess = checkVaildity[1];
        changedElement.value = event.target.value
        changedElement.touched = true;
        updatedControls[elementID] = changedElement;
        let formValid = true
        for (let field in updatedControls) {
            formValid = updatedControls[field].valid && formValid;
        }
        this.setState({ editUserForm: updatedControls, formValid: formValid, formError: '' })
    }

    inputClickedHandler = (event, elementID) => {
        let updatededitUserForm = { ...this.state.editUserForm };
        let currentInputElement = { ...updatededitUserForm[elementID] };
        const hasCountryCodeStart = event.target.value.startsWith("+")
        if (elementID === 'Phone' & !hasCountryCodeStart) {
            event.target.value = '+' + event.target.value
            currentInputElement.value = event.target.value
            updatededitUserForm[elementID] = currentInputElement;
            this.setState({
                editUserForm: updatededitUserForm,
                formError: ''
            })
        }
    }

    onSubmitHandler = (event) => {
        event.preventDefault()
        const authData = {}
        let token = localStorage.getItem('idToken');
        for (let key in this.state.editUserForm) {
            authData[key] = this.state.editUserForm[key].value
        }
        const { name, userName, Phone } = authData
        let profilePic = null
        if (this.state.currentImg.imgEdited) {
            profilePic = this.state.currentImg.editedImgSrc
        }
        if (this.state.formValid) {
            if (!token) {
                const fireUser = auth.currentUser
                if (fireUser) {
                    fireUser.getIdToken(true)
                        .then(responseToken => {
                            token = responseToken
                        })
                        .catch(error => console.log(error))
                }
                else {
                    console.log(fireUser)
                }
            }
            this.props.onEditeUser(token, name, userName, Phone.slice(1), profilePic)
            this.props.showEditeUserFormHandler()

        } else {
            console.log('error')
            this.setState({ formError: 'Invaild input' })
        }
    }

    render() {
        let errorEL;
        const authForm = [];
        for (let key in this.state.editUserForm) {
            authForm.push(
                {
                    id: key,
                    config: this.state.editUserForm[key]
                })
        }
        if (this.state.formError) {
            errorEL = <p className={classes.ErrorEL}>{this.state.formError}</p>
        }
        let imag = <img src={this.props.userProfile.profile_picture} alt='Profile pic' width='70px' height='70px' />;
        if (this.state.currentImg.imgEdited) {
            imag = <img src={this.state.currentImg.editedImgSrc} alt='Profile pic' width='70px' height='70px' />
        }
        const form =
            (
                <form onSubmit={this.onSubmitHandler}>
                    <div className={classes.ProfilePic}>
                        <p>Profile Picture</p>
                        {imag}
                        <label>
                            <input type='file' onChange={event => {
                                const file = event.target.files.item(0);
                                let reader = new FileReader();
                                let base46Img = null;
                                const ImgTypes = ['image/jpeg', 'image/png', 'image/gif']
                                const validType = ImgTypes.some(type => file.type === type)
                                const currentImgUpdate = { ...this.state.currentImg };


                                if (validType) {
                                    reader.readAsDataURL(file);
                                    reader.onload = () => {
                                        base46Img = reader.result;
                                        currentImgUpdate.imgEdited = true;
                                        currentImgUpdate.editedImgSrc = base46Img
                                        this.setState({ currentImg: currentImgUpdate })
                                    }
                                }
                            }} />
                            edit
                        </label>

                    </div>
                    {authForm.map(inputElement => {
                        return <Input
                            key={inputElement.id}
                            label={inputElement.config.label}
                            inputType={inputElement.config.inputType}
                            inputconfig={inputElement.config.inputConfig}
                            invalid={!inputElement.config.valid}
                            errMess={inputElement.config.errMess}
                            touched={inputElement.config.touched}
                            changed={(event) => { this.inputChangeHandler(event, inputElement.id) }}
                            clicked={event => { this.inputClickedHandler(event, inputElement.id) }}
                        />
                    })}
                    <div className={classes.BtnGroub}>
                        <button className={classes.BtnRed} onClick={() => this.props.showEditeUserFormHandler}> Cancel</button>
                        <button className={classes.Btn}> Save changes</button>
                    </div>
                    {errorEL}
                </form>
            );
        return (
            <div className={classes.Container}>
                {form}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onEditeUser: (token, name, username, phpne, profilePic) => { dispatch(actionCreators.editUserProfile(token, name, username, phpne, profilePic)) }
    }
}

export default connect(null, mapDispatchToProps)(EditUserForm);